import styled from 'styled-components';

export const InlineWarningStyled = styled.div`
  display: flex;
`;
